import { useEffect, useMemo, useState } from "react";
import { cn } from "@/lib/utils";
import firewData from "@/lib/onboardingFirew0rksFrames.json";

/** Fotogramas del paquete firew0rks (MIT), ANSI eliminado al generar el JSON. */
const FRAMES = firewData.frames;
const FRAME_MS = 50;
/** Bucles completos de la animación (~7,5 s por bucle a 50 ms/fotograma). */
const LOOP_COUNT = 2;

/**
 * Animación ASCII en el fondo del lienzo.
 * El padre (`data-ob-ascii-fireworks-backdrop` en `OnboardingCanvasStage`) aporta `absolute inset-0`;
 * este componente solo ocupa ese rectángulo y queda por debajo del grid (`z-[2]` en el hermano).
 */
export default function OnboardingSlideEnterFirew0rksAscii({ playId, onEnded, color = "#facc15", fullscreen = false }) {
  const [idx, setIdx] = useState(0);

  const hex = useMemo(() => (/^#[0-9a-fA-F]{6}$/.test(String(color || "").trim()) ? String(color).trim() : "#facc15"), [color]);

  useEffect(() => {
    if (!playId || !FRAMES?.length) return;
    let i = 0;
    let loopsDone = 0;
    setIdx(0);
    const timer = window.setInterval(() => {
      i = (i + 1) % FRAMES.length;
      setIdx(i);
      if (i === 0) {
        loopsDone += 1;
        if (loopsDone >= LOOP_COUNT) {
          window.clearInterval(timer);
          onEnded?.();
        }
      }
    }, FRAME_MS);
    return () => window.clearInterval(timer);
  }, [playId, onEnded]);

  if (!playId || !FRAMES?.length) return null;

  const text = FRAMES[idx] ?? "";
  const glow = `${hex}66`;

  return (
    <div
      className={cn(
        "pointer-events-none flex h-full min-h-0 w-full items-center justify-center overflow-hidden",
        fullscreen ? "rounded-none" : "rounded-xl"
      )}
      role="presentation"
      aria-hidden
    >
      <pre
        className="max-h-full max-w-full overflow-hidden whitespace-pre font-mono leading-none text-[clamp(0.16rem,2.8vw,0.42rem)]"
        style={{ color: hex, textShadow: `0 0 10px ${glow}` }}
        translate="no"
      >
        {text}
      </pre>
    </div>
  );
}
